import { useMemo } from "react";
import Tabs, { SubTab } from "../../../../components/Tabs";
import { ReportLevel } from "../adminReportsApiSlice";
import { PromptUsageAndPerformanceByLevelRow } from "./adminPromptReportApiSlice";
import { EssayAndDraftCountUsageChart } from "../shared/EssayAndDraftCountUsageChart";
import { TraitScoresChart } from "../shared/TraitScoresChart";
import { reportSubLevelName } from "../adminReportsUtil";

export enum UsageAndPerformanceByLevelSubTabs {
	Usage = "Prompt Usage",
	AvgScores = "Prompt Performance",
}

interface ChartProps {
	level: ReportLevel;
	data: PromptUsageAndPerformanceByLevelRow[];
	hasData: boolean;
}

export default function PromptUsageAndPerformanceByLevelChart(props: ChartProps) {
	const initialSubTabs: SubTab[] = useMemo(
		() => [
			{
				name: UsageAndPerformanceByLevelSubTabs.Usage,
				current: true,
				content: (
					<EssayAndDraftCountUsageChart
						level={props.level}
						data={props.data}
						hasData={props.hasData}
						title={`${reportSubLevelName(props.level)} Prompt Usage`}
						yAxisDataField="name"
						isEssayAndDraftSummaryChart={false}
					/>
				),
			},
			{
				name: UsageAndPerformanceByLevelSubTabs.AvgScores,
				current: false,
				content: (
					<TraitScoresChart
						level={props.level}
						data={props.data}
						hasData={props.hasData}
						title={`${reportSubLevelName(props.level)} Holistic and Trait Scores`}
						yAxisDataField="name"
						totalScoreField="averageScore"
					/>
				),
			},
		],
		[props]
	);

	return (
		props.hasData && (
			<div className="print:hidden mt-8">
				<Tabs
					initialSubTabs={initialSubTabs}
					ariaLabel="Prompt Chart Tabs"
					containerClass="px-4"
				/>
			</div>
		)
	);
}
